module.exports = __webpack_public_path__ + "static/media/icon_upload.7e34a0e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_upload.svg
// module id = 674
// module chunks = 0